import aspireLogo from '../../assets/img/aspire-logo.png';
import './ShowMessage.scss';

const ShowMessage = ({ children }) => {
  return (
    <div className="feedbackMessagePage">
      <div className="feedbackMessageBackdrop" aria-hidden="true" />
      <div className="feedbackMessageCard">
        <img src={aspireLogo} alt="Aspire" className="feedbackMessageBrand" />
        <div className="feedbackMessageContent">{children}</div>
      </div>
    </div>
  );
};

export default ShowMessage;
